<script>
import profileLevelBadge from '@/assets/img/profile/profile-level-badge.svg'

export default {
	name: 'ProfileLevelCard',
	data() {
		return {
			profileLevelBadge
		}
	},
	props: {
		level: {
			type: Number,
			default: 1
		},
		name: {
			type: String,
			default: ''
		},
		range: {
			type: String,
			default: ''
		}
	}
}
</script>

<template>
	<article class="profile-info-card profile-level-card" data-qa="profile-level-card">
		<img class="profile-level-card__badge" :src="profileLevelBadge" alt="" aria-hidden="true">
		<div class="profile-level-card__content">
			<p class="profile-level-card__eyebrow">{{ $t('myArea.headerInfo.currentLevel') }}</p>
			<h2 data-qa="profile-level-name-title">{{ $t('myArea.headerInfo.level', { level, name }) }}</h2>
			<p class="profile-level-card__range" data-qa="profile-level-range-text">{{ range }}</p>
		</div>
	</article>
</template>

<style lang="sass" scoped>
.profile-level-card
	display: flex
	align-items: center
	gap: 1rem

	&__badge
		display: block
		flex: 0 0 4.5rem
		width: 4.5rem
		height: 4.5rem
		border-radius: 50%

	&__content
		min-width: 0

		p, h2
			margin: 0

	&__eyebrow
		font-family: var(--lgei-headline)
		font-size: 0.75rem
		font-weight: 700
		line-height: 1
		text-transform: uppercase
		color: var(--lg-dark-gray-200)

	h2
		margin-top: 0.5rem
		font-family: var(--lgei-headline)
		font-size: 1.25rem
		font-weight: 400
		line-height: 1
		color: var(--lg-red-active)

	&__range
		margin-top: 0.5rem !important
		font-family: var(--lgei-text)
		font-size: 0.75rem
		font-weight: 600
		line-height: 1
		color: var(--lg-mid-gray-200)
</style>
